import React from 'react';
import { Field, EditView } from '@builtbypixel/nucleus';

import setup from './setup';
import {Box, Container} from "@chakra-ui/react";

const EditForm = () => {
  return (
    <EditView setup={setup} isFullWidth={false}>
      <Container
          p={{ base: '10px', sm: '15px' }}
          w='100%'
          variant='card'
          rounded='none'
          maxWidth='none'
      >
        <Box display='flex' flexDir='row' gridGap='3'>
            <Field auto isFullWidth name="title" component="text" label="Title" />
            <Field auto isFullWidth name="link" component="text" label="Link" />
        </Box>

          <Field auto isFullWidth name="excerpt" component="richtext" label="Excerpt" />

          <Field auto isFullWidth name="banner_image" component="file" label="Banner Images" />
      </Container>
    </EditView>
  );
};

export default EditForm;
